import React from "react";
import { useForm } from "react-hook-form";
import { EnvelopeIcon } from "../../../../assets/icons";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import CommonFormFieldWrapper from "../../../../common/components/form-field-wrapper/CommonFormFieldWrapper";
import styles from "./HelpForm.module.scss";
import { usePostHelpMessageMutation } from "../../../../service/user-service";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "../../../../stores/slices/loader-slice";
import { useDispatch } from "react-redux";

interface IProps {
	onClose: () => void;
}

type helpFormObject = {
	fullName: string;
	email: string;
	phoneNumber: string;
	subject: string;
	message: string;
};

const HelpForm = ({ onClose }: IProps) => {
    const [ postHelpMessage ] = usePostHelpMessageMutation();
    const dispatch = useDispatch();
	const {
		register,
		handleSubmit,
		formState: { isValid, errors },
	} = useForm<helpFormObject>({
		reValidateMode: "onSubmit",
		mode: "onTouched", // Validate fields on touch
		criteriaMode: "all",
	});

	const onSubmit = (data: helpFormObject) => {
         dispatch(showLoader())
        postHelpMessage(data).unwrap().then( res=>{
            toast.success("Someone will review your request and get back to you in no time")
            onClose();
        }).catch( err=> toast.error(err.data?.title || "Something went wrong"))
        .finally(()=> dispatch(hideLoader()))
	};

	return (
		<CommonDialog onCloseDialog={onClose}>
			<div className={styles.container}>
				<div className={styles.header}>
					<h2 className={styles.headerText}>Get in Touch !</h2>
					<div className={styles.iconCircle}>
						<EnvelopeIcon />
					</div>
					<p className={styles.emailText}>info@yansaafrica.com</p>
				</div>
				<div className={styles.formContainer}>
					<CommonFormFieldWrapper errors={errors?.fullName?.message ? [errors.fullName.message] : []} title="Full Name" required>
						<input
							type="text"
							placeholder="Enter Full Name"
							{...register("fullName", {
								required: "Fullcname Required",
							})}
						/>
					</CommonFormFieldWrapper>
					<CommonFormFieldWrapper errors={errors?.email?.message ? [errors.email.message] : []} title="Email address" required>
						<input
							type="text"
							placeholder="Enter Email address"
							{...register("email", {
								required: "Email Required",
								pattern: {
									value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
									message: "Invalid email",
								},
							})}
						/>
						{errors.email && <p className={styles.error}>{errors.email.message}</p>}
					</CommonFormFieldWrapper>
					<CommonFormFieldWrapper title="Phone Number" errors={errors?.phoneNumber?.message ? [errors.phoneNumber.message] : []} required>
						<input
							type="text"
							placeholder="Enter Phone Number"
							{...register("phoneNumber", {
								required: "Phone number Required",
							})}
						/>
						{errors.phoneNumber && <p className={styles.error}>{errors.phoneNumber.message}</p>}
					</CommonFormFieldWrapper>
					<CommonFormFieldWrapper title="Subject" errors={errors?.subject?.message ? [errors.subject.message] : []} required>
						<input
							type="text"
							placeholder="Enter Subject"
							{...register("subject", {
								required: "Subject Required",
							})}
						/>
						{errors.subject && <p className={styles.error}>{errors.subject.message}</p>}
					</CommonFormFieldWrapper>
					<CommonFormFieldWrapper title="Message">
						<textarea
							rows={5}
							placeholder="Your Message"
							{...register("message", {
								required: "Message Required",
							})}
						/>
						{errors.message && <p className={styles.error}>{errors.message.message}</p>}
					</CommonFormFieldWrapper>
					<div style={{ paddingTop: 30 }}>
						<button
							onClick={handleSubmit(onSubmit)}
							className={`${styles.button} ${!isValid ? styles.disabledButton : ""}`}
							type="submit"
							disabled={!isValid} // Disable button when form is invalid
						>
							Send Message
						</button>
					</div>
				</div>
			</div>
		</CommonDialog>
	);
};

export default HelpForm;
